import { X } from "lucide-react";

const EditRole = ({ onClose }) => {
  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[40%] bg-white">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 text-black ">
            <div>
              <h2 className="text-lg lg:text-xl font-popinsSemiBold">Edit Role</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <form className="w-[90%] mx-auto my-3 lg:my-5">
            <div class="relative w-full">
              <label className="font-popinsMedium text-sm">Email Address</label>
              <input
                type="email"
                placeholder="Email"
                class="peer w-full font-popinsMedium rounded-md border-2 mt-1 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3]"
              />
            </div>
            <div class="relative w-full mt-3 lg:mt-5">
              <label className="font-popinsMedium text-sm">Role</label>
              <input
                type="email"
                placeholder="Email"
                class="peer w-full font-popinsMedium rounded-md border-2 mt-1 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-[#3FC4E3] focus:shadow-[0_0_3px_#3FC4E3]"
              />
            </div>
            <div className="w-[90%] mt-4 lg:mt-6">
              <p className="font-popinsSemiBold text-lg">
                Assigned Permissions
              </p>
              <div className="flex flex-col lg:flex-row lg:justify-between mt-2 lg:mt-3">
                <div className="flex gap-x-2 lg:gap-x-3 items-center w-full lg:w-[49%]">
                  <input
                    type="checkbox"
                    class="peer size-3 lg:size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-sm lg:text-base">
                    User Management
                  </p>
                </div>
                <div className="flex gap-x-2 lg:gap-x-3 items-center w-full lg:w-[49%] mt-2 lg:mt-0">
                  <input
                    type="checkbox"
                    class="peer size-3 lg:size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-sm lg:text-base">
                    Event Oversight
                  </p>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row lg:justify-between mt-2 lg:mt-4">
                <div className="flex gap-x-2 lg:gap-x-3 items-center w-full lg:w-[49%]">
                  <input
                    type="checkbox"
                    class="peer size-3 lg:size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-sm lg:text-base">NGO Approvals</p>
                </div>
                <div className="flex gap-x-2 lg:gap-x-3 items-center w-full lg:w-[49%]">
                  <input
                    type="checkbox"
                    class="peer size-3 lg:size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-sm lg:text-base">
                    Reports & Analytics
                  </p>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row lg:justify-between mt-2 lg:mt-4">
                <div className="flex gap-x-2 lg:gap-x-3 items-center w-full lg:w-[49%]">
                  <input
                    type="checkbox"
                    class="peer size-3 lg:size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-sm lg:text-base">
                    Municipality Approvals
                  </p>
                </div>
                <div className="flex gap-x-2 lg:gap-x-3 items-center w-full lg:w-[49%]">
                  <input
                    type="checkbox"
                    class="peer size-3 lg:size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-sm lg:text-base">
                    Platform Settings
                  </p>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row lg:justify-between mt-2 lg:mt-4">
                <div className="flex gap-x-2 lg:gap-x-3 items-center">
                  <input
                    type="checkbox"
                    class="peer size-4 font-popinsMedium rounded-md border-2 border-border bg-white px-4 py-2 text-black/50 outline-none transition-all duration-300 ease-in-out focus:border-themeColor focus:shadow-[0_0_3px_#3FC4E3]"
                  />
                  <p className="font-popinsRegular text-base">
                    Content Moderation
                  </p>
                </div>
              </div>
              <div className="flex justify-between mt-3 lg:mt-4">
                <p className="font-popinsRegular text-sm lg:text-base">Status</p>
                <label class="inline-flex items-center cursor-pointer relative pl-3">
                  <input type="checkbox" class="sr-only peer" />
                  <div
                    class="relative w-9 h-5 flex items-center bg-white border border-themeColor rounded-full transition-all duration-300
                                                    peer-focus:outline-none
                                                    peer-checked:bg-themeColor
                                                    after:content-[''] after:absolute after:left-[2px]
                                                    after:bg-themeColor after:border after:border-themeColor after:rounded-full
                                                    after:h-4 after:w-4 after:transition-all after:duration-300
                                                    peer-checked:after:translate-x-[18px] peer-checked:after:bg-white peer-checked:after:border-themeColor"
                  ></div>
                </label>
              </div>
            </div>
            <div className="flex justify-end mt-3 lg:mt-5">
              <button
                type="submit"
                className="relative overflow-hidden py-3 px-7 bg-[#3FE36B] text-black font-popinsSemiBold text-sm mt-8 rounded-md shadow-lg
           transform transition duration-300 ease-in-out
           hover:bg-[#3FE36B]/90 hover:scale-105 hover:shadow-[0_0_20px_rgba(63,196,227,0.6)] 
           active:scale-95 active:shadow-inner focus:outline-none
           disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
              >
                Save
                <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditRole;
